<template>
  <div class="ui-content">
    <div class="ui-tableBox">
      <div class="ui-tableBox-bar">
        <p class="ui-tableBox-title">数据列表</p>
      </div>
      <div class="ui-tableList">
        <el-table v-loading="loading" :data="tableList" :max-height="tableHeight" :default-sort="{prop: 'tbSort', order: 'ascending'}" border style="width: 100%" :header-cell-style="{background: '#FAFAFA'}">
          <el-table-column align="center" type="index" width="68px" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="tbStartTime" label="测量时间">
          </el-table-column>
          <el-table-column align="center" prop="tbValue" label="测量值">
            <template slot-scope="{row}">
              {{row.tbValue + unit}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="statusName" label="结果">
          </el-table-column>
        </el-table>
      </div>
      <pagination class="ui-papagination" @size-change="page.pagingSizeChange" @current-change="page.pagingCurrentChange" :total="page.total" :pageSizes="page.pageSizes" :pageSize="page.pageSize" :currentPage="page.currentPage"></pagination>
    </div>
  </div>
</template>
<script>


const files = require.context('/', false, /\.vue$/)
const suffixList = files.id.split(' ')[0].split('/').filter((a, b) => b > 2)
const fileName = 'bloodOxygen'
const type = 3
const unit = '%'
const getStatus = (i) => {
  if (Number(i.tbValue) >= 95) {
    i.statusName = '正常'
    i.status = 1
  } else {
    i.statusName = '偏低'
    i.status = 0
  }
  return i
}
import { debounceUtils } from '@/utils/common.js'
import { mapGetters } from 'vuex'
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this
    return {
      unit: unit,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      detailName: `${fileName}Detail`,
      loading: true,
      tableHeight: null,
      page: {
        currentPage: 1, //当前页
        pageSize: 10, //每页记录数
        total: 10,
        pageSizes: [10, 20, 50, 100],
        pagingSizeChange (value) {
          _this.page.currentPage = 1
          _this.page.pageSize = value
          _this.getList()
        },
        pagingCurrentChange (value) {
          _this.page.currentPage = value
          _this.getList()
        }
      },
      tableList: [],
      seach: {
        type: type
      }
    }
  },
  computed: {
    ...mapGetters([
      'lastBreadCrumb',
      'refreshPage'
    ])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.getList()
        this.$store.dispatch('setRefreshPage', false)
      }
    }
  },
  methods: {
    getList: debounceUtils(function () {
      this.loading = true
      this.seach.page = this.page.currentPage
      this.seach.size = this.page.pageSize
      this.seach.tbUserId = this.$route.query.tbId
      this.$http.get(`/user/findHealthList`, this.seach)
        .then(res => {
          this.loading = false
          if (res.code === 1000) {
            this.tableList = res.data.list.map(getStatus)
            this.page.total = res.data.total
          } else {
            this.$message.error(res.message)
          }
        })
    }, 500)
  },
  destroyed () {
    this.destroyResizeListen(340)
  },
  created () {
    this.addResizeListen(340)
  },
  mounted () {
    this.getList()
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-tableBox {
    margin: 0 24px;
    width: calc(100% - 48px);
    background: #ffffff;
    border-radius: 2px;
    height: calc(100% - 24px);
    position: relative;
    .ui-tableBox-bar {
      position: relative;
      margin: 0 24px;
      height: 64px;
      .ui-tableBox-title {
        height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 24px;
        display: inline-block;
        margin-top: 20px;
      }
      .ui-tableBox-button {
        width: 108px;
        position: relative;
        float: right;
        top: 16px;
        margin-left: 24px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        &.export {
          padding: 8px 15px;
          width: auto;
        }
        ::v-deep .el-icon-arrow-up,
        ::v-deep .el-input__inner {
          height: 30px;
          line-height: 30px;
          border: none;
          &::-webkit-input-placeholder {
            color: #606266;
          }
          &::-moz-placeholder {
            color: #606266;
          }
          &::-ms-input-placeholder {
            color: #606266;
          }
        }
        &:focus {
          outline: none;
        }
      }
    }
    .ui-tableList {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      margin: 8px 24px 0 24px;
      .ui-box-tableList-img {
        width: 80px;
        height: 80px;
        background: #d8d8d8;
        display: inline-block;
        vertical-align: top;
      }
      .ui-box-tableList-label {
        margin: 0 5px 10px;
      }
      .ui-box-tableList-editImg {
        width: 43px;
        cursor: pointer;
        height: 43px;
      }
      .ui-box-tableList-tempSaveImg {
        width: 41px;
        height: 41px;
        position: absolute;
        left: -2px;
        top: -3px;
      }
      ::v-deep .el-table__body-wrapper {
        height: auto !important;
      }
      .ui-tableList-button {
        padding: 9px 17px;
        outline: none;
      }
      .ui-tableList-link.is-underline:hover:after {
        border: none;
      }
    }
  }
}
</style>